import { lazy, Suspense } from "react";
import { Navigate, type RouteObject } from "react-router-dom";

import Home from "../pages/home/page";
const PayoutCasino = lazy(() => import("../pages/home/payoutCasino"));
const CryptoCasino = lazy(() => import("../pages/home/cryptoCasino"));
const GamesProviders = lazy(() => import("../pages/home/gamesProviders"));
const BnGames = lazy(() => import("../pages/home/bnGames"));
const JiliGames = lazy(() => import("../pages/home/jiliGames"));
const CQ9Games = lazy(() => import("../pages/home/cq9Games"));
const PegasusGames = lazy(() => import("../pages/home/pegasusGames"));
const JokerGames = lazy(() => import("../pages/home/jokerGames"));
const RichGaming = lazy(() => import("@/pages/home/richGaming"));
const LiveDealer = lazy(() => import("../pages/home/liveDealer"));
const Evolution = lazy(() => import("@/pages/home/evolution"));
const PragmaticPlay = lazy(() => import("@/pages/home/pragmaticPlay"));
const AsiaGaming = lazy(() => import("@/pages/home/asiaGaming"));
const Playtech = lazy(() => import("@/pages/home/playtech"));
const AboutUs = lazy(() => import("@/pages/home/aboutus"));

function RouteFallback() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#1e3a8a] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function withSuspense(El: React.LazyExoticComponent<React.ComponentType>) {
  return (
    <Suspense fallback={<RouteFallback />}>
      <El />
    </Suspense>
  );
}


const routes: RouteObject[] = [
  /* Home Page */
  {
    path: "/",
    element: <Home />,
  },

  /* Payout Casino Page */
  {
    path: "/fastpayout-ewallet-gaming-casino",
    element: withSuspense(PayoutCasino),
  },

  /* Crypto Casino Page */
  {
    path: "/crypto-ewallet-casino-australia",
    element: withSuspense(CryptoCasino),
  },

  /* Provide Guide Page */
  {
    path: "/ewallet-casino-providers",
    element: withSuspense(GamesProviders),
  },
  {
    path: "/ewallet-casino-providers/:companyId",
    element: withSuspense(GamesProviders),
  },
  {
    path: "/ewallet-casino-providers/:companyId/:providerId",
    element: withSuspense(GamesProviders),
  },

  /* BNG Game Page */
  {
    path: "/bng-ewallet-slots",
    element: withSuspense(BnGames),
  },
  {
    path: "/bng-ewallet-slots/:slug?",
    element: withSuspense(BnGames),
  },

  /* JILI Game Page */
  {
    path: "/jili-slot-games",
    element: withSuspense(JiliGames),
  },

  /* CQ9 Game Page */
  {
    path: "/cq9-ewallet-casino-games",
    element: withSuspense(CQ9Games),
  },
  {
    path: "/cq9-ewallet-casino-games/:slug?",
    element: withSuspense(CQ9Games),
  },

  /* Pegasus Game Page */
  {
    path: "/pegasus-ewallet-games",
    element: withSuspense(PegasusGames),
  },
  {
    path: "/pegasus-ewallet-games/:slug?",
    element: withSuspense(PegasusGames),
  },

  /* Joker Game Page */
  {
    path: "/joker-online-slots",
    element: withSuspense(JokerGames),
  },
  {
    path: "/joker-online-slots/:slug?",
    element: withSuspense(JokerGames),
  },

  /* Rich Gaming Page */
  {
    path: "/rich-gaming-ewallet-games",
    element: withSuspense(RichGaming),
  },
  {
    path: "/rich-gaming-ewallet-games/:slug?",
    element: withSuspense(RichGaming),
  },

  /* Live Dealer Page */
  {
    path: "/live-dealer-australia-casino",
    element: withSuspense(LiveDealer),
  },
  {
    path: "/live-dealer-australia-casino/evolution",
    element: withSuspense(Evolution),
  },
  {
    path: "/live-dealer-australia-casino/pragmaticplay",
    element: withSuspense(PragmaticPlay),
  },
  {
    path: "/live-dealer-australia-casino/asiagaming",
    element: withSuspense(AsiaGaming),
  },
  {
    path: "/live-dealer-australia-casino/playtech",
    element: withSuspense(Playtech),
  },

  /* About Us Page */
  {
    path: "/about-us",
    element: withSuspense(AboutUs),
  },

  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

export default routes;
